export const INITIAL_GPT_QUOTA = 50;
